<template>
  <div class="contact-information">
    <div class="row header">
      <div class="col-12 mb-3 mt-2">
        <em
          class="fas rounded-circle p-1 mr-2 color-green shadow bg-white"
          :class="editModel.isNew ? 'fa-plus' : 'fa-edit'"
        />
        <span>
          {{ editModel.isNew ? 'Añadir' : 'Editar' }} Contacto
          {{ editModel.isPrimary ? 'Primario' : 'Secundario' }}
        </span>
      </div>
    </div>
    <div class="row body">
      <div class="col">
        <div class="col-xs-12">
          <validation-observer ref="formValidator">
            <contact-information
              v-model="editModel"
              :civil-statuses="civilStatuses"
            />
          </validation-observer>
        </div>
        <div class="col-xs-12">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <check-box
                v-model="editModel.isPrimary"
                class="mb-2"
                :disabled="disablePrimary || isPrimaryInitiallySelected"
                text="Primario"
              />
            </div>
            <div class="col-sm-12 col-md-6 text-right pt-3">
              <action-button
                class="mr-2 py-2 w-18 btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="cancel"
              />
              <action-button
                class="py-2 w-17"
                i="fas fa-save"
                text="Guardar"
                variant="success"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactInformation from './ContactInformation';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'ContactInformationAddEdit',
  components: {
    ContactInformation,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disablePrimary: {
      type: Boolean,
      default: () => false,
    },
    civilStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editModel: Object.assign({}, this.value), //Copy the model to eliminate the reference
      isPrimaryInitiallySelected: false,
    };
  },
  watch: {
    value: function(newValue) {
      this.editModel = Object.assign({}, newValue); //Copy the model to eliminate the reference
    },
  },
  mounted() {
    this.isPrimaryInitiallySelected = this.value.isPrimary;
  },
  methods: {
    async save() {
      const isValid = await this.$refs.formValidator.validate();

      if (isValid) {
        const payload = { ...this.editModel };
        payload.civilStatusId = parseFloat(this.editModel.civilStatus?.id);
        this.$emit('on-saved', payload);
      } else {
        //TODO: Use the stored one
        this.ShowToast('Error', 'Información incompleta. (190803)', 'error');
      }
    },
    async cancel() {
      this.$emit('on-cancel');
    },
  },
};
</script>
<style scoped>
@media (min-width: 576px) {
  .contact-information .header {
    padding-left: 0.25 !important;
    padding-right: 0.25 !important;
  }

  .contact-information .body {
    padding-left: 0.43 !important;
    padding-right: 0.43 !important;
  }

  .contact-information .btnCancel {
    float: left;
  }
}

@media (min-width: 768px) {
  .contact-information .header {
    padding-left: 0.33rem !important;
    padding-right: 0.33rem !important;
  }

  .contact-information .body {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .contact-information .btnCancel {
    float: inherit;
  }
}

@media (min-width: 992px) {
  .contact-information .header {
    padding-left: 0.66rem !important;
    padding-right: 0.66rem !important;
  }

  .contact-information .body {
    padding-left: 1.75rem !important;
    padding-right: 1.75rem !important;
  }
}

@media (min-width: 1200px) {
  .contact-information .header {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .contact-information .body {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
}
</style>
